import { Link, useNavigate } from "react-router-dom"
import { MyContext } from "../Context";
import { useContext } from "react";


export default function TablePlaintes({data}){


    console.log(data)
    const navigate = useNavigate();
    const {actifItem, setActifItem} = useContext(MyContext);
    
    

    const tableItems = [
        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Ouverte'
        },

        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Expirée'
        },

        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Expirée'
        },

        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Expirée'
        },

        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Expirée'
        },

        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Cloturée'
        },

        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Cloturée'
        },

        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Cloturée'
        },

        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Cloturée'
        },

        {
            id: "PLT-TYTF-HUHGF-POR",
            date: "10 Janv 2023",
            plaignant : 'Jean Mabiala',
            object : 'Reservation annulée et non remboursée',
            statut : 'Cloturée'
        },
        
    ]

    return (
        <div className="">
            <div className="max-w-lg">
                <div>
                    <h3 className="text-xl font-bold text-gray-800 sm:text-2xl dark:text-gray-200">
                        Plaintes
                    </h3>
                    
                </div>

                
            </div>
            <div className="mt-12 overflow-x-auto rounded-lg shadow-sm">
                <table className="w-full text-sm text-left table-auto">
                    <thead className="font-medium text-gray-600 bg-gray-200 border-b border-gray-600 dark:text-gray-200 dark:bg-gray-800">
                        <tr>
                            <th className="px-6 py-3">Id</th>
                            <th className="px-6 py-3">Titre</th>
                            <th className="px-6 py-3">Plaignant(e)</th>
                            <th className="px-6 py-3">Type</th>
                            <th className="px-6 py-3">Date</th>
                            <th className="px-6 py-3">Statut</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 divide-y">
                        {
                            data.map((item, idx) => (
                                
                                    <tr key={idx} className="w-full text-left transition bg-gray-200 border-gray-600 rounded cursor-pointer hover:bg-gray-200 duration-900 dark:text-gray-200 hover:text-gray-800 dark:bg-gray-800"
                                        onClick={()=>{
                                            navigate(`/plainte/details/${idx}`)
                                            setActifItem('Plaintes')
                                        }}
                                    >
                                        
                                            <td className="flex items-center px-6 py-3 gap-x-3 whitespace-nowrap">
                                                <div>
                                                    <span className="block text-sm font-medium">{item.id}</span>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.title}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.client.firstname}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{item.type}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">{new Date(item.createdAt).toLocaleDateString()}</td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className=
                                                    {
                                                    `
                                                        ${item.state === 'ABORDTED' && 'bg-red-600 bg-opacity-15 font-bold text-sm text-red-800 rounded-xl text-center px-4 py-1' } 
                                                        ${item.state === 'RESOLVED' && 'bg-green-600 bg-opacity-15 font-bold text-sm text-green-800 rounded-xl text-center px-4 py-1'}
                                                        ${item.state === 'PROCESSING' && 'bg-purple-600 bg-opacity-15 font-bold text-sm text-purple-800 rounded-xl text-center px-4 py-1'}
                                                        ${item.state === 'INWAITING' && 'bg-gray-600 bg-opacity-15 font-bold text-sm text-gray-800 dark:text-gray-600 hover:dark:text-gray-700 rounded-xl text-center px-4 py-1'}

                                                    `
                                                    
                                                    }>{item.state}</span></td>
                                    </tr>
                                
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}